// SelectCountryList
import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { getItemById, getRegions } from './../../actions';

const portalTarget = typeof document !== 'undefined' ? document.body : null;

const selectStyles = {
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999999999,
    }),
};

const SelectCountryList = ({
    setValue,
    setFocus,
    setTouch,
    setFilled,
    label,
    value
}) => {
    const dispatch = useDispatch();

    const { regions, regionObj } = useSelector((state) => state.region);
    const authUser = useSelector((state) => state.auth?.user);
    const userRegion = authUser?.region;

    useEffect(() => {
        dispatch(getRegions());
    }, [dispatch]);

    useEffect(() => {
        if (userRegion) {
            dispatch(getItemById("region", userRegion, "_id name", "components"));
        }
    }, [dispatch, userRegion]);

    const options = useMemo(() => {
        if (!Array.isArray(regions)) {
            return [];
        }

        return regions.map((item) => ({
            label: item.name,
            value: item._id,
        }));
    }, [regions]);

    const defaultRegion = useMemo(() => {
        if (!regionObj?._id) {
            return null;
        }

        return {
            label: regionObj.name,
            value: regionObj._id,
        };
    }, [regionObj]);

    useEffect(() => {
        if (!value && defaultRegion) {
            setValue(defaultRegion);
            setFilled?.(true);
        }
    }, [value, defaultRegion, setValue, setFilled]);

    const selectedValue = value || defaultRegion || null;

    const handleChange = (selectedOption) => {
        setValue(selectedOption);
        setFilled?.(!!selectedOption);
        setTouch?.(false);
    };

    const handleFocus = () => {
        setFocus?.(true);
        setTouch?.(true);
    };

    const handleBlur = () => {
        if (!selectedValue) {
            setFocus?.(false);
            setFilled?.(false);
            return;
        }

        setTouch?.(false);
        setFilled?.(true);
    };

    return (
        <div className="selectCountryList">
            {label ? (
                <label className="selectCountryList__label">
                    {label}
                </label>
            ) : null}

            <Select
                className="selectCountryList__select"
                classNamePrefix="regionSelect"
                options={options}
                value={selectedValue}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder="Выберите область"
                noOptionsMessage={() => "Области не найдены"}
                loadingMessage={() => "Загрузка областей..."}
                isClearable
                isSearchable
                menuPlacement="auto"
                menuShouldScrollIntoView={false}
                menuPortalTarget={portalTarget}
                styles={selectStyles}
            />
        </div>
    );
};

export default SelectCountryList;